import { Box } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import CustomDatePicker from "../../../../../components/CustomDatePicker";
import Flex from "../../../../../components/Flex";
import SearchInput from "../../../../../components/SearchInput";
import { AccountReceivableFilterType } from "./account-receivable-constant";

interface AccountReceivableFilterProps {
  filter: AccountReceivableFilterType;
  setFilter: Dispatch<SetStateAction<AccountReceivableFilterType>>;
  search: string;
  setSearch: (v: string) => void;
}

/**
 * Filters for the Insurance and Patient tabs. The Summary tab no longer takes
 * any filter input — it always reports on the current day.
 */
const AccountReceivableFilter = ({
  filter,
  setFilter,
  search,
  setSearch,
}: AccountReceivableFilterProps) => {
  return (
    <Flex gap={1} alignItems="center">
      <Box width="220px">
        <CustomDatePicker
          placeholder="Search by Date"
          value={filter.startDate}
          onChange={(v) =>
            setFilter({
              ...filter,
              startDate: v && v.isValid() ? v.toDate() : null,
              endDate: null,
            })
          }
        />
      </Box>
      <Box width="220px">
        <SearchInput
          placeholder="Search by Payer Name, ID"
          name="Search by Payer Name, ID"
          onSearch={setSearch}
          searchKey={search}
        />
      </Box>
      {/* Group by select removed — the Summary tab no longer exposes filters.
      <Box width="160px">
        <CustomSelect
          placeholder="Group by"
          options={SUMMARY_GROUPING_OPTIONS}
          value={filter.grouping ?? null}
          onChange={(val) => setFilter({ ...filter, grouping: val })}
        />
      </Box> */}
    </Flex>
  );
};

export default AccountReceivableFilter;
